/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerDto } from '../../models/customer-dto';

export interface GetCustomer$Params {
}

export function getCustomer(http: HttpClient, rootUrl: string, params?: GetCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerDto>> {
  const rb = new RequestBuilder(rootUrl, getCustomer.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerDto>;
    })
  );
}

getCustomer.PATH = '/api/v1/auth';
